/**
 * Pure PICKER selection math — the freely-re-selectable choice logic shared by the
 * New Game starter gallery and trainer gallery, kept free of Phaser so the
 * "click A, then B, and B is selected" contract is unit-testable (mirrors menuNav /
 * loreNav / savePicker).
 *
 * The whole point: selection is STATELESS w.r.t. the prior pick. Picking any option
 * simply makes that option the chosen one — there is no latch, no "first pick wins",
 * so cards never get stuck. A scene maps each card's id to `isSelected(id, chosen)`
 * to drive its highlight.
 */

/**
 * The chosen id after picking `pickedId`. Always returns `pickedId` when it is a
 * known option (free re-selection); falls back to the current `chosen` when the
 * picked id is unknown, so a stray click never clears a valid choice.
 */
export function pick(options: readonly string[], chosen: string, pickedId: string): string {
  return options.includes(pickedId) ? pickedId : chosen;
}

/** Whether `id` is the chosen option (drives each card's highlight/ring). */
export function isSelected(id: string, chosen: string): boolean {
  return id === chosen;
}
